module.exports = __webpack_public_path__ + "static/media/color1.9bc2cff2.svg";